import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { Component } from 'react';
import { Button } from '../button';
import './copy-button.less';
export class CopyButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false,
        };
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        this.setState({
            clicked: true,
        });
        this.props.onClick();
        setTimeout(() => {
            this.setState({
                clicked: false,
            });
        }, 2000);
    }
    render() {
        const rootClass = classnames({
            'copy-button': true,
            'copy-button--clicked': this.state.clicked,
        }, this.props.className);
        return (_jsxs(Button, Object.assign({ className: rootClass, onClick: this.handleClick }, { children: [_jsx(DixaIcon, { className: "copy-button__icon", icon: "copy" }), "Copy"] })));
    }
}
